export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const MODAL_CLOSE_SEC = 1.5;
export const RES_PER_PAGE = 10;
export const KEY = '8ef73153-d90c-4734-a942-7cc0ecd49b07';
